import React from "react";
import { useEffect, useState } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/theme-tomorrow';
import style from './response.module.css';

const ResponseBody = ({ data, viewAs, wrap }) => {
  return (
    <div className={style.response_body}>
      {viewAs === 'preview' && (
        <>
          {typeof data === 'object' ? (
            <div className={style.res_preview}>{JSON.stringify(data)}</div>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: data }}></div>
          )}
        </>
      )}
      {viewAs === 'raw' && (
        <div className={style.res_raw}>
          <pre>
            {typeof data === 'object' ? JSON.stringify(data, null, 2) : data}
          </pre>
        </div>
      )}
      {viewAs === 'pretty' && (
        <div className="pretty_response">
          {typeof data === 'object' ? (
            <AceEditor
              mode="json"
              fontSize={13}
              theme="tomorrow"
              value={JSON.stringify(data, null, 2)}
              name="prettyJsonOutput"
              tabSize={2}
              editorProps={{
                $blockScrolling: true,
              }}
              readOnly={true}
              wrapEnabled={wrap}
              highlightActiveLine={false}
              style={{ width: '100%' }} // Optional: ensure full width
            />
          ) : (
            <AceEditor
              mode="html"
              fontSize={13}
              theme="tomorrow"
              value={data}
              name="prettyJsonOutput"
              tabSize={2}
              editorProps={{
                $blockScrolling: true,
              }}
              readOnly={true}
              wrapEnabled={wrap}
              highlightActiveLine={false}
              style={{ width: '100%' }} // Optional: ensure full width
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ResponseBody;